import { render, staticRenderFns } from "./SelectJSON.vue?vue&type=template&id=121ffe94&scoped=true"
import script from "./SelectJSON.vue?vue&type=script&lang=js"
export * from "./SelectJSON.vue?vue&type=script&lang=js"
import style0 from "./SelectJSON.vue?vue&type=style&index=0&id=121ffe94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ffe94",
  null
  
)

export default component.exports